<div class="row mt-2" style="border-top: 4px solid #5271ff;"></div>
<div class="row mt-2">
    <div class="col-md-2">
        <label>Year</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownListYear" [(ngModel)]="selectedItemsYear"
            (onSelect)="onChangeSingleYear($event)" (onDeSelect)="onChangeSingleYear($event)" [placeholder]="'Year'">
        </ng-multiselect-dropdown>
    </div>
    <div class="col-md-2" *ngIf="viewMonth">
        <label>Month</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownListMonth"
            [(ngModel)]="selectedItemsMonth" (onSelect)="onChangeSingleMonth($event)"
            (onDeSelect)="onChangeSingleMonth($event)" [placeholder]="'Month'">
        </ng-multiselect-dropdown>
    </div>
    <div class="col-md-2">
        <label>Order Cluster</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownListOrderCluster"
            [(ngModel)]="selectedItemsOrderCluster" (onSelect)="onChangeSingleCluster($event)"
            (onDeSelect)="onChangeSingleCluster($event)" [placeholder]="'Order Cluster'">
        </ng-multiselect-dropdown>
    </div>
    <div class="col-md-2">
        <label>Lead Operator</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownListLead" [(ngModel)]="selectedItemsLead"
            (onSelect)="onChangeSingleLead($event)" (onDeSelect)="onChangeSingleLead($event)"
            [placeholder]="'Lead Member'">
        </ng-multiselect-dropdown>
    </div>

    <div class="col-md-2">
        <label>Customer</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownListCustomer"
            [(ngModel)]="selectedItemsCustomer" (onSelect)="onChangeSingleCustomer($event)"
            (onDeSelect)="onChangeSingleCustomer($event)" [placeholder]="'Customer'">
        </ng-multiselect-dropdown>
    </div>

    <div class="col-md-2" *ngIf="!viewMonth">
        <label>B Operator</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownListBO" [(ngModel)]="selectedItemsBO"
            (onSelect)="onChangeSingleBo($event)" (onDeSelect)="onChangeSingleBo($event)" [placeholder]="'B Member'">
        </ng-multiselect-dropdown>
    </div>

</div>
<div class="row mt-2">


    <div class="col-md-2" *ngIf="viewMonth">
        <label>B Operator</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownListBO" [(ngModel)]="selectedItemsBO"
            (onSelect)="onChangeSingleBo($event)" (onDeSelect)="onChangeSingleBo($event)" [placeholder]="'B Member'">
        </ng-multiselect-dropdown>
    </div>
    <div class="col-md-2">
        <label>Country</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownListCountry"
            [(ngModel)]="selectedItemsCountry" (onSelect)="onChangeSingleCountry($event)"
            (onDeSelect)="onChangeSingleCountry($event)" [placeholder]="'Country'">
        </ng-multiselect-dropdown>
    </div>


    <div class="col-md-2">
        <label>Order Type</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownListOrderType"
            [(ngModel)]="selectedItemsOrderType" (onSelect)="onChangeSingleOrderType($event)"
            (onDeSelect)="onChangeSingleOrderType($event)" [placeholder]="'Order Type'">
        </ng-multiselect-dropdown>
    </div>

    <div class="col-md-2" *ngIf="viewOrderStatus">
        <label>Order Status</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownListOrderStatus"
            [(ngModel)]="selectedItemsOrderStatus" (onSelect)="onChangeSingleOrderStatus($event)"
            (onDeSelect)="onChangeSingleOrderStatus($event)" [placeholder]="'Order Status'">
        </ng-multiselect-dropdown>
    </div>



</div>
<div class="row mt-4">
    <span *ngIf="overviewOrderdDetailReportSpan" class="style-span">
        In this view the orders information is based on the order creation date
    </span>
    <span *ngIf="slaKpiSpan" class="style-span">
        In this view the orders information is based on the order completion date
    </span>
    <span *ngIf="completedDetailSpan" class="style-span">
        In this view the orders information is based on the order completion date
    </span>
</div>
<div class="row mt-4" style="border-bottom: 4px solid #5271ff;"></div>